import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../styles/LogoList.css';
import { Logo } from './tablet/Logo';

export function LogoList({
  logos,
  customerId,
  title,
  subTitle,
  handleAddNewLogo,
  activeLogoIndex,
  handleActiveLogoIndex,
}) {
  return (
    <div id={customerId}>
      <div
        style={{
          position: 'relative',
          padding: '0px 8px',
          height: '100%',
        }}
      >
        <Swiper
          slidesPerView="auto"
          spaceBetween={10}
          freeMode={true}
          modules={[FreeMode]}
          className="logo-list-swiper"
        >
          <SwiperSlide key="key" className="custom-slide">
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="addLogo">
                <img src="/theme/img/plusIcon.svg" alt="plusIcon" />
                <input
                  className="fullOwner_opacity"
                  type="file"
                  name="myfile"
                  accept="image/*"
                  style={{ width: '100%', height: '100%' }}
                  onChange={(e) => handleAddNewLogo(e)}
                />
              </div>
            </div>
          </SwiperSlide>
          {logos?.map((model, index) => {
            const isNew = model.Position === null;
            return (
              <SwiperSlide key={index} className="custom-slide">
                <Logo
                  scale={model.Scale}
                  rotate={model.Rotate}
                  image={model.Thumbnail}
                  onClick={() => handleActiveLogoIndex(index)}
                  active={activeLogoIndex === index}
                  isNew={isNew}
                  title={title}
                  subTitle={subTitle}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
